import { _get, _post, _delete, _put, _patch } from "./index";
// 获取搜索框补全数据
export const policy_search_list = (data: any) => {
  const req = {
    data,
    url: "zstapi/user/company/corporateNameCompletion",
  };
  return _get(req);
};
// 获得单个企业信息详情
export const search_company_data = (parameter: any) => {
  const req = {
    data: { parameter },
    url: "zstapi/user/company/getCorporateInfo",
  };

  return _get(req);
};
